import React, { forwardRef } from 'react'

import { IconProps } from './types'

const ArrowUp = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={props.width ?? size}
      height={props.height ?? size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path d="M4 8L8 4M8 4L12 8M8 4V13" stroke={color} />
    </svg>
  ),
)
ArrowUp.displayName = 'ArrowUp'
ArrowUp.defaultProps = {
  width: 16,
  height: 16,
}

export default ArrowUp
